/*
 * sb-hero-stones.js
 * Interaktive Kies-/Edelsplitt-Animation für den Schotterberg Hero.
 * Framework-frei (Vanilla JS + Canvas 2D). Theme-update-sicher.
 *
 * Verwendung im Theme:
 *   1. Diese Datei nach  assets/sb-hero-stones.js  legen.
 *   2. Im Hero-Section ein <canvas data-sb-stones ...> hinter den Inhalt legen
 *      (siehe sb-hero.liquid.patch.md).
 *   3. {{ 'sb-hero-stones.js' | asset_url | script_tag }} defer laden.
 *
 * Idee: Steine (sichtbarer Zierkies/Edelsplitt) fallen aus der Mausposition
 * und bilden echte Haufen (Böschungswinkel-Physik). Der Nutzer "befüllt"
 * spielerisch einen angedeuteten Weg. Ohne Maus rieselt es dezent von selbst.
 * Respektiert prefers-reduced-motion und funktioniert per Touch am Handy.
 */
(function () {
  "use strict";

  var PALETTES = {
    "Natur (warm)": ['#E9DCBE','#D8C49E','#C6B083','#B89F72','#A48B63','#8E7A5C','#726551'],
    "Kühl (Grau)":  ['#DFE1DF','#C7CBCA','#AEB4B3','#969D9D','#7F8788','#6B7274','#565C5e'],
    "Hell (Marmor)":['#F1ECDF','#E4DBC9','#D5CBB4','#C6BB9F','#B7AB8B','#A79A78','#928668']
  };
  var MOTION = {
    "Subtil":     { pour: 20, idle: 1.6 },
    "Ausgewogen": { pour: 32, idle: 3 },
    "Lebhaft":    { pour: 50, idle: 5 }
  };

  function shade(hex, amt) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    var f = function (c) { return amt >= 0 ? Math.round(c + (255 - c) * amt) : Math.round(c * (1 + amt)); };
    var cl = function (v) { return v < 0 ? 0 : v > 255 ? 255 : v; };
    return 'rgb(' + cl(f(r)) + ',' + cl(f(g)) + ',' + cl(f(b)) + ')';
  }

  function Stones(canvas, opts) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    opts = opts || {};
    this.palette = PALETTES[opts.palette] ? opts.palette : "Kühl (Grau)";
    this.motion = MOTION[opts.motion] ? opts.motion : "Subtil";
    this.interactive = opts.interactive !== false;
    this.pointer = { x: -9999, y: -9999, active: false };
    this._idle = 0; this._acc = 0; this._settledCount = 0;
    this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._loopB = this._loop.bind(this);
    this._bind();
    this._resize();
    this._last = performance.now();
    this.raf = requestAnimationFrame(this._loopB);
  }

  Stones.prototype._pal = function () { return PALETTES[this.palette]; };
  Stones.prototype._mo = function () { return MOTION[this.motion]; };

  Stones.prototype._pebblePath = function (ctx, pts) {
    ctx.beginPath();
    var n = pts.length;
    ctx.moveTo((pts[n - 1].x + pts[0].x) / 2, (pts[n - 1].y + pts[0].y) / 2);
    for (var i = 0; i < n; i++) {
      var cur = pts[i], nx = pts[(i + 1) % n];
      ctx.quadraticCurveTo(cur.x, cur.y, (cur.x + nx.x) / 2, (cur.y + nx.y) / 2);
    }
    ctx.closePath();
  };

  Stones.prototype._makeSprite = function (base) {
    var R = 46, pad = Math.round(R * 0.55), size = (R + pad) * 2;
    var cv = document.createElement('canvas'); cv.width = cv.height = size;
    var cx = cv.getContext('2d'), c = R + pad;
    var n = 8 + ((Math.random() * 4) | 0);
    var flat = 0.7 + Math.random() * 0.18;
    var baseAng = Math.random() * Math.PI;
    var pts = [];
    for (var i = 0; i < n; i++) {
      var a = (i / n) * Math.PI * 2 + (Math.random() - 0.5) * 0.28;
      var rr = R * (0.8 + Math.random() * 0.2);
      pts.push({
        x: c + Math.cos(a) * rr * Math.cos(baseAng) - Math.sin(a) * rr * flat * Math.sin(baseAng),
        y: c + Math.cos(a) * rr * Math.sin(baseAng) + Math.sin(a) * rr * flat * Math.cos(baseAng)
      });
    }
    cx.save();
    cx.shadowColor = 'rgba(0,0,0,0.42)'; cx.shadowBlur = R * 0.45; cx.shadowOffsetX = R * 0.1; cx.shadowOffsetY = R * 0.34;
    cx.fillStyle = shade(base, -0.5); this._pebblePath(cx, pts); cx.fill();
    cx.restore();
    var g = cx.createLinearGradient(c - R * 0.7, c - R * 0.7, c + R * 0.75, c + R * 0.8);
    g.addColorStop(0, shade(base, 0.4)); g.addColorStop(0.42, base); g.addColorStop(1, shade(base, -0.5));
    this._pebblePath(cx, pts); cx.fillStyle = g; cx.fill();
    var rg = cx.createRadialGradient(c, c, R * 0.35, c, c, R * 1.02);
    rg.addColorStop(0, 'rgba(0,0,0,0)'); rg.addColorStop(1, 'rgba(0,0,0,0.28)');
    this._pebblePath(cx, pts); cx.fillStyle = rg; cx.fill();
    cx.save(); this._pebblePath(cx, pts); cx.clip();
    for (var s = 0; s < 7; s++) {
      var sa = Math.random() * Math.PI * 2, sr = Math.random() * R * 0.7;
      cx.globalAlpha = 0.12 + Math.random() * 0.18;
      cx.fillStyle = Math.random() < 0.5 ? shade(base, 0.5) : shade(base, -0.55);
      cx.beginPath(); cx.arc(c + Math.cos(sa) * sr, c + Math.sin(sa) * sr, R * (0.05 + Math.random() * 0.08), 0, Math.PI * 2); cx.fill();
    }
    cx.restore();
    cx.globalAlpha = 0.5; cx.fillStyle = 'rgba(255,255,255,0.7)';
    cx.beginPath(); cx.ellipse(c - R * 0.34, c - R * 0.38, R * 0.22, R * 0.13, -0.6, 0, Math.PI * 2); cx.fill();
    cx.globalAlpha = 1;
    return { cv: cv, R: R, size: size };
  };

  Stones.prototype._buildSprites = function () {
    var pal = this._pal(); this.sprites = [];
    for (var i = 0; i < pal.length; i++) for (var v = 0; v < 3; v++) this.sprites.push(this._makeSprite(pal[i]));
  };

  Stones.prototype._colOf = function (x) { var c = (x / this.colW) | 0; if (c < 0) c = 0; if (c >= this.cols) c = this.cols - 1; return c; };
  Stones.prototype._surfaceY = function (x) { return this.H - this.heights[this._colOf(x)]; };

  Stones.prototype._makeStone = function (x, y) {
    var r = 4.6 + Math.random() * 4.4;
    return { x: x, y: y, r: r, vx: 0, vy: 0, rot: Math.random() * Math.PI * 2, vr: (Math.random() - 0.5) * 5, si: (Math.random() * this.sprites.length) | 0 };
  };

  Stones.prototype._pour = function (px, py) {
    if (this._settledCount >= this.cap) return;
    var s = this._makeStone(px + (Math.random() - 0.5) * 22, py + (Math.random() - 0.5) * 14);
    s.vx = (Math.random() - 0.5) * 26; s.vy = 25 + Math.random() * 45;
    this.falling.push(s);
  };

  Stones.prototype._deposit = function (s) {
    var c = this._colOf(s.x), step = this.colW * 0.85;
    for (var k = 0; k < 80; k++) {
      var hc = this.heights[c];
      var hl = c > 0 ? this.heights[c - 1] : Infinity;
      var hr = c < this.cols - 1 ? this.heights[c + 1] : Infinity;
      var dl = hc - hl, dr = hc - hr;
      if (dl > step && dl >= dr) c--;
      else if (dr > step) c++;
      else break;
    }
    var dep = s.r * 1.28;
    this.heights[c] = Math.min(this.maxH, this.heights[c] + dep);
    s.x = c * this.colW + this.colW * 0.5 + (Math.random() - 0.5) * this.colW * 0.7;
    s.y = this.H - this.heights[c] + dep * 0.45;
    s.vr = 0;
    this.settled.push(s); this._settledCount++;
  };

  Stones.prototype._resize = function () {
    var host = this.canvas.parentElement || this.canvas;
    var W = host.clientWidth || this.canvas.clientWidth, H = host.clientHeight || this.canvas.clientHeight;
    if (!W || !H) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    this.canvas.width = W * dpr; this.canvas.height = H * dpr;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.W = W; this.H = H;
    this.colW = 9; this.cols = Math.ceil(W / this.colW) + 1;
    this.maxH = H * 0.6; this.cap = Math.round(W * 2.4);
    this._buildSprites();
    if (!this.heights || this.heights.length !== this.cols) {
      this.heights = new Float32Array(this.cols);
      this.settled = []; this.falling = []; this._settledCount = 0;
    }
    this._pathY = H - 26; this._pathH = 20; this._pathX0 = W * 0.16; this._pathX1 = W * 0.9;
  };

  Stones.prototype._drawStone = function (ctx, s) {
    var sp = this.sprites[s.si]; if (!sp) return;
    var w = sp.size * (s.r / sp.R);
    ctx.save(); ctx.translate(s.x, s.y); ctx.rotate(s.rot);
    ctx.drawImage(sp.cv, -w / 2, -w / 2, w, w); ctx.restore();
  };

  Stones.prototype._drawPath = function (ctx) {
    if (this._settledCount > this.cap * 0.25) return;
    ctx.save();
    ctx.globalAlpha = 0.16 * (1 - this._settledCount / (this.cap * 0.25));
    ctx.strokeStyle = 'rgba(20,16,11,0.85)';
    ctx.lineWidth = 2; ctx.setLineDash([2, 10]); ctx.lineCap = 'round';
    var y = this._pathY;
    ctx.beginPath();
    ctx.moveTo(this._pathX0, y); ctx.lineTo(this._pathX1, y);
    ctx.moveTo(this._pathX0, y - this._pathH); ctx.lineTo(this._pathX1, y - this._pathH);
    ctx.stroke(); ctx.restore();
  };

  Stones.prototype._loop = function (now) {
    var dt = Math.min(0.05, (now - this._last) / 1000); this._last = now;
    var ctx = this.ctx, W = this.W, H = this.H;
    if (!ctx || !W) { this.raf = requestAnimationFrame(this._loopB); return; }
    var mo = this._mo();

    if (!this.reduce) {
      this._idle += dt;
      var px, py, rate;
      if (this.interactive && this.pointer.active) {
        px = this.pointer.x; py = Math.min(this.pointer.y, this._surfaceY(this.pointer.x) - 30); rate = mo.pour;
      } else {
        px = W * (0.5 + 0.4 * Math.sin(this._idle * 0.22)); py = -18 - Math.random() * 30; rate = mo.idle;
      }
      this._acc += dt * rate;
      while (this._acc >= 1) { this._acc -= 1; this._pour(px, py); }
    }

    for (var i = this.falling.length - 1; i >= 0; i--) {
      var f = this.falling[i];
      f.vy += 1450 * dt; f.x += f.vx * dt; f.y += f.vy * dt; f.rot += f.vr * dt;
      if (f.y + f.r * 0.6 >= this._surfaceY(f.x) && f.vy > 0) { this.falling.splice(i, 1); this._deposit(f); }
      else if (f.y > H + 50 || f.x < -60 || f.x > W + 60) { this.falling.splice(i, 1); }
    }

    ctx.clearRect(0, 0, W, H);
    this._drawPath(ctx);
    for (var a = 0; a < this.settled.length; a++) this._drawStone(ctx, this.settled[a]);
    for (var b = 0; b < this.falling.length; b++) this._drawStone(ctx, this.falling[b]);

    this.raf = requestAnimationFrame(this._loopB);
  };

  Stones.prototype._bind = function () {
    var self = this, cv = this.canvas, host = cv.parentElement || cv;
    this._onMove = function (e) {
      var r = cv.getBoundingClientRect();
      var t = e.touches && e.touches[0];
      var cx = t ? t.clientX : e.clientX, cy = t ? t.clientY : e.clientY;
      var x = cx - r.left, y = cy - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) { self.pointer.active = false; return; }
      self.pointer.x = x; self.pointer.y = y; self.pointer.active = true;
    };
    this._onLeave = function () { self.pointer.active = false; };
    window.addEventListener('mousemove', this._onMove, { passive: true });
    document.addEventListener('mouseleave', this._onLeave, { passive: true });
    host.addEventListener('touchmove', this._onMove, { passive: true });
    host.addEventListener('touchstart', this._onMove, { passive: true });
    host.addEventListener('touchend', this._onLeave, { passive: true });
    this._onResize = function () { self._resize(); };
    window.addEventListener('resize', this._onResize);
    if (window.ResizeObserver) { this._ro = new ResizeObserver(function () { self._resize(); }); this._ro.observe(host); }
  };

  Stones.prototype.destroy = function () {
    cancelAnimationFrame(this.raf);
    window.removeEventListener('mousemove', this._onMove);
    document.removeEventListener('mouseleave', this._onLeave);
    window.removeEventListener('resize', this._onResize);
    if (this._ro) this._ro.disconnect();
  };

  function initEl(cv) {
    if (cv._sbStones) return;
    cv._sbStones = new Stones(cv, {
      palette: cv.getAttribute('data-sb-palette'),
      motion: cv.getAttribute('data-sb-motion'),
      interactive: cv.getAttribute('data-sb-interactive') !== 'false'
    });
  }
  function initAll(root) {
    (root || document).querySelectorAll('canvas[data-sb-stones]').forEach(initEl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  // Shopify Theme-Editor: bei Section-Reload neu initialisieren / aufräumen
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('canvas[data-sb-stones]').forEach(function (cv) {
      if (cv._sbStones) { cv._sbStones.destroy(); cv._sbStones = null; }
    });
  });

  window.SchotterbergStones = Stones;
})();
